module.exports = __webpack_public_path__ + "img/Artboard-3.bcd83f79.png";